import MojitoApplications from 'mojito/applications';

import {ensureStartingSlash} from '#core/utils/url-utils.js';

const {selectors: routerSelectors} = MojitoApplications.Common.RouterStore;

export function isInternalUrl(url) {
    const routeResolver = routerSelectors.getRouteResolver();
    const root = (routeResolver && routeResolver.getRoot()) || '/';

    return url.startsWith(root) || url.startsWith(`${document.location.origin}${root}`);
}

export function isHomeUrl(url) {
    url = ensureStartingSlash(url);
    const routeResolver = routerSelectors.getRouteResolver();
    const home = ensureStartingSlash((routeResolver && routeResolver.getRoute({type: 'HOME'})) || '/');

    return url === home;
}
